import styled from 'styled-components/native';
import {TouchableOpacity} from 'react-native';

export const ListItem = styled(TouchableOpacity)`
  width: 100%;
`;
